// @flow
import * as React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { Button } from 'reactstrap';

import ReportState from 'components/ReportState';
import { Spacing, Colors } from 'utils/styleguide';

export type TimelineEntryType = 'comment' | 'like' | 'state';
export type TimelineEntry = {
  type: TimelineEntryType,
  createdByEmail?: string,
  createdByName?: string,
  isCreatedByManager: boolean,
  text?: string,
  createdAt: Number,
  isOwnEntry?: boolean,
};

type Props = TimelineEntry & {|
  +onEditClick: () => void,
|};

const translateTypeToTitle = (type: TimelineEntryType): string => {
  switch (type) {
    case 'comment':
      return 'Kommentar';
    case 'like':
      return 'Unterstützung';
    case 'state':
      return 'Statusänderung';
  }
  return 'NOT SET';
};

const translateTypeToColor = (type: TimelineEntryType): string => {
  switch (type) {
    case 'comment':
      return 'primary';
    case 'like':
      return 'success';
    case 'state':
      return 'warning';
  }
  return 'NOT SET';
};

const translateTypeToIcon = (type: TimelineEntryType): string => {
  switch (type) {
    case 'comment':
      return 'icon-bubble';
    case 'like':
      return 'icon-heart';
    case 'state':
      return 'icon-bell';
  }
  return 'NOT SET';
};

class TimelineEntryComponent extends React.Component<Props> {
  _renderName(name: ?string, isCreatedByManager: boolean) {
    const userIcon = isCreatedByManager ? (
      <i className={classNames('icon-star', 'text-warning')} />
    ) : (
      <i className={classNames('icon-user')} />
    );
    return name ? (
      <span>
        {userIcon} {name}
      </span>
    ) : (
      ''
    );
  }

  _renderEmail(email: ?string) {
    return email ? (
      <span>
        (<a href={`mailto:${email}`}>{email}</a>) -{' '}
      </span>
    ) : (
      ''
    );
  }

  render() {
    const {
      type,
      createdByEmail,
      createdByName,
      isCreatedByManager,
      text,
      createdAt,
      isOwnEntry,
      onEditClick,
    } = this.props;

    const color = translateTypeToColor(type);
    return (
      <div style={styles.root}>
        <div
          style={styles.icon}
          className={classNames(translateTypeToIcon(type), `bg-${color}`)}
        />
        <div style={styles.meta}>
          <div style={styles.title} className={classNames(`text-${color}`)}>
            {translateTypeToTitle(type)}{' '}
            {type === 'state' && <ReportState state={text} />}
          </div>
          <div style={styles.creation}>
            {this._renderName(createdByName, isCreatedByManager)}{' '}
            {this._renderEmail(createdByEmail)}
            <i className={classNames('icon-calendar')} /> erstellt am{' '}
            {moment(createdAt).format('DD. MMMM YYYY - HH:mm')}
          </div>
          {!!text &&
            type !== 'state' && (
              <div style={styles.text}>
                {text}
                {!!isOwnEntry && (
                  <Button color="link" size="sm" onClick={() => onEditClick()}>
                    (bearbeiten)
                  </Button>
                )}
              </div>
            )}
        </div>
      </div>
    );
  }
}

const styles = {
  root: {
    display: 'flex',
    marginBottom: Spacing.Micro,
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'pink',
    width: 42,
    height: 42,
    marginRight: Spacing.Micro,
    fontSize: 20,
    flexShrink: 0,
  },
  title: {
    fontWeight: 'bold',
  },
  creation: {
    color: Colors.LightGrey,
  },
  text: {
    marginTop: Spacing.Nano,
  },
  meta: {},
};

export default TimelineEntryComponent;



// WEBPACK FOOTER //
// ./src/components/Timeline/TimelineEntry.js